// extracted by mini-css-extract-plugin
export default {"Wrapper":"AddPortfolioModel_Wrapper__uY8Rn","Title":"AddPortfolioModel_Title__yebMW","Buttons":"AddPortfolioModel_Buttons__r9TY6"};